import { render, staticRenderFns } from "./OptionSideBar.vue?vue&type=template&id=08c29300&scoped=true&"
import script from "./OptionSideBar.vue?vue&type=script&lang=ts&"
export * from "./OptionSideBar.vue?vue&type=script&lang=ts&"
import style0 from "./OptionSideBar.vue?vue&type=style&index=0&id=08c29300&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c29300",
  null
  
)

export default component.exports